import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Root error boundary (backlog P5). Before this existed, any render throw
 * white-screened the whole SPA with no way back but a manual reload.
 * Styling mirrors the StatusScreen in index.tsx.
 */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            color: '#002628',
            padding: 24,
          }}
        >
          <div style={{ fontSize: 22, fontWeight: 800, color: '#008481' }}>CleanSpaces</div>
          <h1 style={{ fontSize: 26, margin: '16px 0 8px' }}>Something went wrong</h1>
          <p style={{ color: '#707070', maxWidth: 420 }}>
            An unexpected error occurred in this page. Your data is safe. Reload to continue
            working, and contact support if this keeps happening.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 16,
              padding: '10px 28px',
              borderRadius: 8,
              border: 'none',
              background: '#00a8a3',
              color: '#fff',
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
